import type { ObservatoryView } from "./schema";
import type { AppliedPeriod } from "./useReportingPeriod";

// Returning waves compare complete calendar months, not partial range-edge months.
export function completeTrendView(
  view: ObservatoryView,
  period: AppliedPeriod | null,
): ObservatoryView {
  if (!period) return view;
  const complete = (month: string) => {
    if (!/^20\d{2}-(0[1-9]|1[0-2])$/.test(month)) return false;
    const last = new Date(
      Date.UTC(Number(month.slice(0, 4)), Number(month.slice(5)), 0),
    )
      .toISOString()
      .slice(0, 10);
    return month + "-01" >= period.from && last <= period.to;
  };
  return {
    ...view,
    series: view.series.filter((row) => complete(row.month)),
    dimensions: {
      ...view.dimensions,
      months: (view.dimensions.months ?? []).filter((row) =>
        complete(row.label),
      ),
    },
  };
}
